import type { SupportedColorValues } from '../types';

type Props = {
  fillColor: SupportedColorValues; // actually, want it to be a sactioned colour name.
};

const NoSearchResults = ({ fillColor }: Props) => (
  <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.538 0c9.668 0 17.539 7.514 17.539 16.825 0 3.96-1.424 7.595-3.804 10.465l-.17.202 5.59 5.517 2.525 2.492A2.61 2.61 0 0 1 40 37.364l-.005.169a2.61 2.61 0 0 1-.777 1.695c-.454.448-1.03.7-1.622.759l-.177.012h-.179a2.678 2.678 0 0 1-1.799-.77l-8.381-8.273-.146.091a18.008 18.008 0 0 1-9.376 2.604C7.87 33.65 0 26.136 0 16.825 0 7.515 7.87 0 17.538 0zm.308 5.08c-6.816 0-12.308 5.277-12.308 11.745 0 6.469 5.492 11.746 12.308 11.746s12.308-5.277 12.308-11.746c0-6.468-5.492-11.746-12.308-11.746zm.183 15.275c.722 0 1.33.604 1.33 1.322 0 .718-.608 1.323-1.33 1.323-.723 0-1.33-.605-1.33-1.323s.607-1.322 1.33-1.322zM18.143 10C20.537 10 22 11.266 22 12.967c0 1.568-1.064 2.324-2.014 2.985-.722.53-1.387.983-1.387 1.738 0 .303.17.643.418.85l-1.673.549a2.15 2.15 0 0 1-.684-1.606c0-1.266.912-1.909 1.73-2.495.703-.49 1.33-.925 1.33-1.662 0-.737-.57-1.36-1.806-1.36-1.159 0-1.995.528-2.64 1.322L14 11.87C14.97 10.699 16.432 10 18.143 10z"
      fill={fillColor}
      fillRule="nonzero"
    />
  </svg>
);

export { NoSearchResults };
